import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import PortfolioDetails from 'components/views/blog/blogDetails';

const BlogRoutes = () => (
    <Switch>
        <Route exact path="/blog/blog-detail/:slug" component={PortfolioDetails} />
        <Route path="/blog/*">
            <Redirect to="/" />
        </Route>
    </Switch>
);

export default BlogRoutes;
